import React, { useState } from 'react';
import CommunicatorTemplateModal from './communicatorTemplateModal';
// @ts-ignore
import { Link as UILinkAragUILib, Loader } from 'arag-ui-lib';
import { Link } from 'react-router-dom';
import GENERAL_FUNCTIONS from '../../utils/functions/functions';
import DownloadIcon from '../icons/downloadIcon';
import codes from '../../utils/constants/codes';
import ProgressBar from '../general/progressBar/progressBar';
import { useTranslation } from 'react-i18next';

type Props = {
    log: {
        fileId: string | null;
        fileName: string | null;
        template: string | null;
        templateContent: any;
    };
    isDisabled: boolean;
    clickDownloadHandler: Function;
    isLoadingDownload: string | null;
    progressFileDownload: any;
};

const ClaimCommunicatorTemplate = (props: Props): JSX.Element => {
    const { t } = useTranslation();
    const {
        log,
        isDisabled,
        clickDownloadHandler,
        isLoadingDownload,
        progressFileDownload,
    } = props;
    const [communicatorTemplateOpen, setCommunicatorTemplateOpen] =
        useState<boolean>(false);
    const openCommunicatorTemplate = () => {
        setCommunicatorTemplateOpen(true);
    };
    const closeCommunicatorTemplate = () => {
        setCommunicatorTemplateOpen(false);
    };

    return (
        <div>
            <CommunicatorTemplateModal
                communicatorTemplateOpen={communicatorTemplateOpen}
                closeCommunicatorTemplate={closeCommunicatorTemplate}
                log={log}
            />

            <div>
                <p>{t('documentAdded') as string}</p>
                <Link
                    onClick={e => {
                        e.preventDefault();
                        openCommunicatorTemplate();
                    }}
                    to={undefined as any}
                    style={{
                        pointerEvents: isDisabled ? 'none' : 'auto',
                        color: isDisabled ? '#000' : 'default',
                    }}
                >
                    {log.fileName}
                </Link>
                <br />
                <br />
                <UILinkAragUILib
                    variant={'primary'}
                    onClick={async () => {
                        await clickDownloadHandler(
                            log.fileId,
                            log.fileName,
                            codes.template,
                        );
                    }}
                    label={
                        <div className="download-icon-wrapper">
                            {' '}
                            <DownloadIcon className="download-icon" />{' '}
                            {t<string>('download')}{' '}
                        </div>
                    }
                    disabled={isDisabled}
                />
                {isLoadingDownload === log.fileId &&
                    !progressFileDownload?.find(
                        (item: { id: string }) => item.id === log.fileId,
                    )?.id && (
                        <div className={'row'} style={{ marginTop: '10px' }}>
                            <ProgressBar
                                progress={{
                                    id: isLoadingDownload as string,
                                    progress: 0,
                                }}
                                mainStyles={'col-sm-9'}
                            />
                        </div>
                    )}
            </div>
        </div>
    );
};

export default ClaimCommunicatorTemplate;
